import React from 'react'
import { Tabs, Tab } from 'react-bootstrap';
import { Grid, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const OfferList = ({ hideFilter = false, withoutCat = false, withoutSearchOrFilter = false, countyList = false, showExtraHeading = false, noMarginTop = false }) => {
    return (
        <div className="radius_section" style={{marginTop: noMarginTop ? '0px' : ''}}>
            {
                !withoutSearchOrFilter && (
                    <div className="flex_grp_align_center justify-content-between search_input_grp mt-2 mb-2">
                        <div className={`left-icon shimmerBG shimmer-text-lg ${hideFilter ? 'w-100' : 'w-70'}`}>
                            {/* input_icon_search flex1 */}
                            {/* <input
                            type="text"
                            className="form-control"
                            placeholder=""
                        ></input> */}
                            {/* <button className="pe-none">
                            <img
                                src={process.env.PUBLIC_URL + '/assets/images/search_dark.svg'}
                                alt=""
                                title=""
                            />
                        </button> */}
                        </div>
                        {
                            !hideFilter && (
                                <button
                                    className="filter_btn shimmerBG shimmer-text-lg w-20"

                                >
                                    {/* <img
                                src={process.env.PUBLIC_URL + '/assets/images/fillter-icon.svg'}
                                alt=""
                                title=""
                            />
                            Filter */}
                                </button>
                            )
                        }
                    </div>
                )
            }


            {
                !withoutCat && !countyList && (
                    <Tabs
                        defaultActiveKey={1}
                        transition={true}
                        id="uncontrolled-tab-example"
                        className="tabs_shimmer cs_tabs mb-4"
                    >
                        {[1, 2, 3].map((item, index) => {
                            return (
                                <Tab key={`index-${index}`} eventKey={item} title="">
                                    {/* <RenderAllNojoomPartners /> */}
                                    <div className="flex_grp_between mt-2 mb-3">
                                        <h3 className="section_title_light mb-0 shimmerBG shimmer-text-sm w-40"></h3>
                                        <a className="hyperlink shimmerBG shimmer-text-xs w-20">
                                            {/* View All */}
                                            {/* <img
                                        src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'}
                                        alt=""
                                        title=""
                                    /> */}
                                        </a>
                                    </div>

                                    <Swiper
                                        className="column_swiper_1 swiper_vertical_slide"
                                        spaceBetween={12}
                                        slidesPerView={1.1}
                                        grid={{ rows: 3, fill: 'column' }}
                                        modules={[Grid, Pagination]}
                                        style={{ gridAutoFlow: "row", display: "grid" }}
                                    >
                                        {[1, 2, 3, 4, 5]?.map((item, index) => {
                                            return (
                                                <>
                                                    <SwiperSlide key={`index-${index}`}>
                                                        <div className="card_style_2 height_100">
                                                            <div className="card_img shimmerBG shimmer-img-xs" style={{ width: '50px' }}>
                                                                {/* <img
                                                            src={process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'}
                                                            alt=""
                                                            title=""
                                                        /> */}
                                                            </div>
                                                            <div className="card_info">
                                                                <div className="card_info_grp">
                                                                    <h4 className='shimmerBG shimmer-text-xs w-40 mb-2'></h4>
                                                                    <p className='shimmerBG shimmer-p-text height-10 mb-1 mt-1'></p>
                                                                    <p className='shimmerBG shimmer-p-text height-10 mb-1'></p>
                                                                    <p className='shimmerBG shimmer-p-text height-10 w-60'></p>
                                                                </div>
                                                                <div className="d-flex justify-content-end card_link w-100">
                                                                    <div className="shimmerBG shimmer-text-xs w-20">
                                                                        {/* View
                                                                <img
                                                                    src={
                                                                        process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
                                                                    }
                                                                    alt=""
                                                                    title=""
                                                                /> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                </>
                                            );
                                        })}
                                    </Swiper>

                                </Tab>
                            );
                        })}
                    </Tabs>
                )
            }

            {
                showExtraHeading && (
                    <div className='mt-5 shimmerBG shimmer-text-sm w-40'></div>
                )
            }

            {
                withoutCat && !countyList && (
                    <div className={withoutSearchOrFilter && (!showExtraHeading) ? 'mt-5' : ''}>
                        {
                            [1, 2, 3]?.map(item => (
                                <div className="card_style_2 height_100 mt-4">
                                    <div className="card_img shimmerBG shimmer-img-xs" style={{ width: '50px' }}>
                                        {/* <img
                                                            src={process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'}
                                                            alt=""
                                                            title=""
                                                        /> */}
                                    </div>
                                    <div className="card_info">
                                        <div className="card_info_grp">
                                            <h4 className='shimmerBG shimmer-text-xs w-40 mb-2'></h4>
                                            <p className='shimmerBG shimmer-p-text height-10 mb-1 mt-1'></p>
                                            <p className='shimmerBG shimmer-p-text height-10 mb-1'></p>
                                            <p className='shimmerBG shimmer-p-text height-10 w-60'></p>
                                        </div>
                                        <div className="d-flex justify-content-end card_link w-100">
                                            <div className="shimmerBG shimmer-text-xs w-20">
                                                {/* View
                                                                <img
                                                                    src={
                                                                        process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
                                                                    }
                                                                    alt=""
                                                                    title=""
                                                                /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                )
            }

            {
                countyList && (
                    <Tabs defaultActiveKey={1} transition={true} id="uncontrolled-tab-example" className=" tabs_shimmer cs_tabs m-0">
                        {[1, 2, 3]?.map(item => (
                            <Tab eventKey={item} title="">
                            <div className='mt-5'>
                                {[1, 2, 3, 4, 5]?.map(response => {
                                            return (
                                                <div
        className="card_style_5 mb-10"
      >
        <div
          className="card_style_5_header flex_grp_align_center"
          aria-controls="example-collapse-text"
        >
          <div className="card_img shimmerBG shimmer-img-xs me-3 mb-0" style={{width: '40px', height: '25px'}}>
            {/* <img className='count-img'
              src={process.env.PUBLIC_URL +
                "/assets/images/country-logos/Afghanistan-sm.png"}
              alt=""
              title=""
            /> */}
          </div>
          <div className="card_info shimmerBG shimmer-text-xs" style={{maxWidth: '100px'}}>
             <span dir="ltr"></span>
          </div>
          <div className="hyperlink" style={{marginLeft: 'auto'}}>
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/right_arrow_dark.svg"
              }
              alt=""
              title=""
            />
          </div>
        </div>
      </div>
                                            )
                                        })}
                            </div>
                        </Tab>
                        ))}
                    </Tabs>
                )
            }
                    





        </div>
    )
}

export default OfferList